import { render, staticRenderFns } from "./internshipdetails.vue?vue&type=template&id=3d4d8c9b&scoped=true"
import script from "./internshipdetails.vue?vue&type=script&lang=js"
export * from "./internshipdetails.vue?vue&type=script&lang=js"
import style0 from "./internshipdetails.vue?vue&type=style&index=0&id=3d4d8c9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4d8c9b",
  null
  
)

export default component.exports